import { Component, OnInit } from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-brouchure',
  templateUrl: './brouchure.component.html',
  styleUrls: ['./brouchure.component.scss']
})
export class BrouchureComponent implements OnInit {

  constructor(
      private meta: Meta,
      private titles: Title
  ) { }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('ARNI Brochure: Download for Program Details and More');
        this.meta.updateTag({
            name: 'description',
            content: `Download the ARNI Brochure to explore our programs, campus facilities, and unique offerings. Get all the information you need to start your journey with us.`
        });
    }

}
